import { render, staticRenderFns } from "./TablaUnidadesNegocio.vue?vue&type=template&id=bc6b099e"
import script from "./TablaUnidadesNegocio.vue?vue&type=script&lang=js"
export * from "./TablaUnidadesNegocio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports